import { FilterSuggestionsBar } from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterSuggestionsBar";
import { useIndustryTaxonomySuggestions } from "app/pages/sales-intelligence/modules/industry/hooks/useIndustryTaxonomySuggestions";

type IndustryTaxonomySuggestionsProps = Parameters<typeof useIndustryTaxonomySuggestions>[0];

export const IndustryTaxonomySuggestions = (props: IndustryTaxonomySuggestionsProps) => {
    const { suggestedItems, isEnabled, isLoading } = useIndustryTaxonomySuggestions(props);

    return (
        <FilterSuggestionsBar
            suggestedItems={suggestedItems}
            isEnabled={isEnabled}
            isLoading={isLoading}
            dataAutomation="industry-taxonomy-suggestions"
        />
    );
};
